// import util from 'util'
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {sortBy} from 'lodash'
import * as _ from 'immutable'
import config from 'config'
import jwtDecode from 'jwt-decode'
import {css, StyleSheet} from 'aphrodite/no-important'
import {getAccessToken, getDomains} from '../selectors'
import Loading from '../components/elements/loading'

const imgPlaceholder = 'data:image/png;base64,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'

const styles = StyleSheet.create({
  userListContainer: {
    margin: 10,
    background: '#fff',
    padding: 20,
    boxShadow: '2px 2px 3px #ccc',
    fontSize: 14,
  },
  tokenInput: {
    width: '100%',
    boxShadow: '3px 3px 3px inset #00000017',
    background: '#fbfbfb',
    border: '1px solid #ccc',
    borderRadius: '3px',
    fontSize: 16,
  },
  userItem: {

  },
  userAvatar: {
    display: 'inline-block',
    height: 50,
    width: 50,
    backgroundSize: 50,
    borderRadius: '50%',
    overflow: 'hidden'
  },
  userName: {
    display: 'inline-block',
    marginLeft: 10,
    transform: 'translateY(-75%)',
  },
  list: {
    listStyle: 'none',
    padding: '10px 20px',
  },
  listItem: {
    display: 'flex',
    margin: 10,
    paddingBottom: 5,
    paddingTop: 5,
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    cursor: 'pointer',
  },
  listItemImage: {
    borderRadius: '50%',
    width: 64,
    height: 64,
    transform: 'translateY(10px)',
  },
  listItemContent: {
    marginLeft: 20,
    minWidth: 300,
    flex: 1,
    fontSize: 14,
  },
  listItemContentH4: {
    margin: 0,
    marginTop: 10,
    fontSize: 16,
  },
  listItemContentRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 14,
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
  },
  availableRoles: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '10px 0',
  },
  availableRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 14,
    // background: 'rgb(75, 110, 153)',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
    cursor: 'pointer',
  },
  listItemContentP: {
    margin: 0,
    marginTop: 5,
    color: '#aaa',
    fontSize: 14,
    lineHeight: '24px',
  },
  userListPager: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
  },
  userListPageChanger: {
    textAlign: 'center',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    margin: '2px 2px',
    padding: '0 7px',
    cursor: 'pointer',
  },
  userListPageNumbers: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  userListPageNumber: {
    textAlign: 'center',
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    borderRadius: '3px',
    margin: '2px 2px',
    padding: '0 7px',
    cursor: 'pointer',
  },
  userListPageCount: {
    textAlign: 'center',
  },
  accessDenied: {
    textAlign: 'center',
    padding: 20,
    fontSize: '24px',
    color: '#d26363',
    fontWeight: '700',
  }
})

const styles2 = StyleSheet.create({
  userProfileContainer: {
    position: 'fixed',
    top: 150, left: 150, right: 150, bottom: 150,
    overflowY: 'scroll',
    background: '#f3f3f3',
    padding: 20,
    boxShadow: '2px 2px 3px #ccc',
    border: '1px solid #ccc',
    borderRadious: '3px',
  },
  listItemContentRole: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 16,
    background: '#fff',
    border: '2px solid rgb(75, 110, 153)',
    color: 'rgb(75, 110, 153)',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'block',
    borderRadius: 5,
  },
  roleEditor: {
    display: 'flex'
  },
  rolebox: {
    flex: '1'
  },
  userJson: {
    fontFamily: 'monospace',
    background: '#fff',
    padding: 5,
    border: '1px solid #ddd'
  },
  button: {
    margin: 0,
    marginTop: 5,
    marginRight: 5,
    fontSize: 16,
    background: 'rgb(75, 110, 153)',
    border: '2px solid rgb(75, 110, 153)',
    color: '#fff',
    fontWeight: '700',
    padding: '2px 10px',
    textAlign: 'center',
    display: 'inline-block',
    borderRadius: 5,
    cursor: 'pointer',
  },
})

function intersect(a, b) {
  return a.filter(Set.prototype.has, new Set(b))
}

const createArray = (size) => {
  const _array = []
  for (let i = 0; i < size; i += 1) {
    _array[i] = i
  }
  return _array
}

const fetchUserList = (accessToken, domainId) => {
  return fetch(
    // `https://user.smartoffice.incubation.io/users?domainIds=["hsbc"]`,
    `${config.USER_URL}/users?domainIds=["${domainId}"]`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    },
  )
    .then((response) => {
      return response.json()
    })
}
const fetchUser = (accessToken, userId) => {
  return fetch(
    `${config.USER_URL}/users/${userId}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    },
  )
    .then((response) => {
      return response.json()
    })
}
const updateUser = (accessToken, userId, body) => {
  return fetch(
    `${config.USER_URL}/users/${userId}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
      responseType: 'json',
      body: JSON.stringify(body)
    },
  )
    .then((response) => {
      return response
    })
}
const fetchAvatar = (accessToken, avatarUrl) => {
  // console.log('fetching data')
  if (!avatarUrl) return imgPlaceholder
  return fetch(
    avatarUrl,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
      responseType: 'blob'
    },
  )
    .then((response) => {
      return response.blob()
    })
    .then((image) => {
      const url = window.URL || window.webkitURL
      const objUrl = url.createObjectURL(image)
      return objUrl
    })
}

const noop = () => {
  return false
}

function AdminUserPage(props) {
  const {user, token, handleProfileSelect, availableRoles, refreshUserList, writeAccess} = props
  const [isLoadingAvatar, setIsLoadingAvatar] = useState(false)
  const [thisUser, setThisUser] = useState(user)
  const [avatar, setAvatar] = useState(imgPlaceholder)
  const [hasChanges, setHasChanges] = useState(false)
  const [userRoles, setUserRoles] = useState(thisUser.roles || [])
  const [selectableRoles, setSelectableRoles] = useState(thisUser.roles ? availableRoles.filter((r) => !thisUser.roles.includes(r.roleName)) : availableRoles || [])
  const [updatedUser, setUpdatedUser] = useState(thisUser.roles)

  async function loadUserAvatar() {
    setIsLoadingAvatar(true)
    const avatarData = await fetchAvatar(token, user.avatarUrl || '')
    setAvatar(avatarData)
    setIsLoadingAvatar(false)
  }


  useEffect(() => {
    loadUserAvatar()
    setUserRoles(thisUser.roles || [])
    setSelectableRoles(thisUser.roles ? selectableRoles.filter((r) => !thisUser.roles.includes(r)) : selectableRoles)
    setUpdatedUser(thisUser)
    setHasChanges(false)
  }, [thisUser])

  useEffect(() => {
    setThisUser(props.user)
  }, [props.user])

  useEffect(() => {
    setUpdatedUser({...user, roles: userRoles})
  }, [userRoles])


  function handleAddRole(role) {
    // setSelectableRoles((prevRoles) => prevRoles.filter((r) => r.roleName !== role))
    setUserRoles((prevRoles) => [...prevRoles, role])
    setHasChanges(true)
  }
  function handleRemoveRole(role) {
    setUserRoles((prevRoles) => prevRoles.filter((r) => r !== role))
    // setSelectableRoles((prevRoles) => [...prevRoles, role])
    setHasChanges(true)
  }
  async function handleSave() {
    const userUpdateResponse = await updateUser(token, thisUser.id, [{ "op": "add", "path": "/roles", "value": updatedUser.roles }])
    // const fetchUserResponse = await fetchUser(token, thisUser.id)
    refreshUserList()
    handleProfileSelect({})
    // console.log(fetchUserResponse)
    // setThisUser(fetchUserResponse)
  }

  const updatedUserComponent = hasChanges ? (
    <>
      <div style={{fontSize: 26, color: '#4b6e99', marginTop: 10}} >User after changes</div>
      <pre className={css(styles2.userJson)}>{JSON.stringify(updatedUser, null, 2)}</pre>
    </>
  ) : ''
  const updateBodyString = hasChanges ? (
    <>
      <div style={{fontSize: 26, color: '#4b6e99'}} >Patch body to be sent to user service</div>
      <pre style={{whiteSpace: 'pre-wrap', fontSize: 12}} className={css(styles2.userJson)}>{`[{ "op": "add", "path": "/roles", "value": "[${updatedUser.roles.map(r => `\\"${r}\\"`).join(',')}]" }]`}</pre>
    </>
  ) : ''
  const saveButton = hasChanges ? <div className={css(styles2.button)} onClick={handleSave}> SAVE </div> : ''

  const writeOnlyContent = writeAccess ? (
    <>
      <div className={css(styles2.roleEditor)}>
        <div style={{fontSize: 26, color: '#4b6e99'}} className={css(styles2.rolebox)}>
          Available roles
        </div>
        <div style={{fontSize: 26, color: '#4b6e99'}} className={css(styles2.rolebox)}>
          Selected roles
        </div>
      </div>
      <div className={css(styles2.roleEditor)}>
        <div className={css(styles2.rolebox)}>
          {selectableRoles && selectableRoles.filter((r) => userRoles && !userRoles.includes(r.roleName)).map((role) => <h4 key={`selectable-${role.roleName}`} onClick={() => handleAddRole(role.roleName)} title={role.description} className={css(styles2.listItemContentRole)} style={{cursor: 'pointer'}}>{role.roleName}</h4>)}
        </div>
        <div className={css(styles2.rolebox)}>
          {userRoles && userRoles.map((role) => <h4 key={`user-${role}`} onClick={() => handleRemoveRole(role)} className={css(styles2.listItemContentRole)} style={{cursor: 'pointer'}}>{role}</h4>)}
        </div>
      </div>
      {updatedUserComponent}
      {updateBodyString}
      {saveButton}
    </>
  ) : <div className={css(styles.accessDenied)} >You only have read access, can't make any changes</div>

  return (
    <div className={css(styles2.userProfileContainer)} >
      <div><img src={avatar} className={css(styles.listItemImage)} /></div>
      <pre className={css(styles2.userJson)}>{JSON.stringify(thisUser, null, 2)}</pre>
      {writeOnlyContent}
      <div onClick={() => handleProfileSelect({})} style={{position: 'absolute', top: 10, right: 10, cursor: 'pointer'}}>X</div>
    </div>
  )
}


// var accessToken
const PAGE_SIZE = 50
const searchPlaceholder = 'Search for name, email or id'

function AdminUserListContainer(props) {
  const accessToken = props.accessToken

  const decodedJWT = jwtDecode(accessToken)
  const {domainIds} = props
  // console.log(decodedJWT)
  const readAccess = decodedJWT.scopes.includes('users:read')
  const writeAccess = decodedJWT.scopes.includes('users:write')
  // console.log(readAccess, writeAccess)
  const [userList, setUserList] = useState([])
  const [selectedRoles, setSelectedRoles] = useState([])
  const [page, setPage] = useState(1)
  const [selectedDomain, setSelectedDomain] = useState(decodedJWT.domainIds[0])
  const [searchString, setSearchString] = useState(searchPlaceholder)
  const [availableRoles, setAvailableRoles] = useState([
    {roleName: 'ROLE_USER', description: 'A standard user, having no roles is the same as having this (old users)'},
    {roleName: 'ROLE_USER_VIEWER_ACROSS_ALL_DOMAINS', description: 'Role for nimway team what allows viewing users for all domains'},
    {roleName: 'ROLE_DOMAIN_ADMIN', description: 'Customer role for access to o365 integration'},
    {roleName: 'ROLE_DOMAIN_PARTNER', description: 'Partner role for installation'},
    {roleName: 'ROLE_SUPER_ADMIN', description: 'Gives access to nimway admin dashboard'},
    {roleName: 'ROLE_DOMAIN_ANALYTICS', description: 'Gived customers access to analytics'},
    {roleName: 'ROLE_SURVEILLANCE_USER', description: 'Administrate monitoring for all domains'},
    {roleName: 'ROLE_SURVEILLANCE_ADMIN', description: 'View monitoring for all domains'},
    {roleName: 'ROLE_DOMAIN_DEVICES_READ', description: 'Allow customers to view devices in the mobile app'},
    {roleName: 'ROLE_INTERNAL_TOOLS_READ', description: 'Read access to internally developed tools'},
    {roleName: 'ROLE_INTERNAL_TOOLS_WRITE', description: 'Write access to internally developed tools'},
  ])
  const [isLoadingUserList, setIsLoadingUserList] = useState(false)
  const [token, setToken] = useState(accessToken)
  const [profileVisible, setProfileVisible] = useState({})

  async function loadUserList() {
    setIsLoadingUserList(true)
    const userListResponse = await fetchUserList(token, selectedDomain)
    userListResponse.message || setUserList(sortBy(userListResponse, 'email'))
    setIsLoadingUserList(false)
  }

  function handleProfileSelect(user) {
    setProfileVisible(user)
  }
  function handleTokenChange(e) {
    setToken(e.currentTarget.value)
  }
  function handleSearch(e) {
    setSearchString(e.currentTarget.value)
  }
  function handleSearchFocus(e) {
    if (searchString === searchPlaceholder) {
      setSearchString('')
    }
  }
  function handleSearchBlur(e) {
    if (e.currentTarget.value === '') {
      setSearchString(searchPlaceholder)
    }
  }
  function handleRoleSelection(role) {
    if (selectedRoles.includes(role)) {
      setSelectedRoles((prevRoles) => prevRoles.filter((r) => r !== role))
    } else {
      setSelectedRoles((prevRoles) => [...prevRoles, role])
    }
    setPage(1)
  }
  function handleDomainSelection(domainId) {
    setSelectedDomain(domainId)
    setPage(1)
  }
  function handlePageChange(newPage) {
    setPage(newPage)
  }

  useEffect(() => {
    setUserList([])
    loadUserList()
  }, [token, selectedDomain])

  useEffect(() => {
    setToken(props.accessToken)
  }, [props.accessToken])

  function refreshUserList() {
    loadUserList()
  }

  // useEffect(() => {
  //   const availRoles = []
  //   userList.forEach((user) => {
  //     user.roles && user.roles.forEach((role) => {
  //       if (!availRoles.includes(role)) {
  //         availRoles.push(role)
  //       }
  //     })
  //   })
  //   setAvailableRoles(availRoles)
  // }, [userList])

  const userListFilteredByRoles = selectedRoles.length ? userList.filter((u) => u.roles && intersect(u.roles, selectedRoles).length) : userList
  var userListFitleredBySearchString
  if (searchString !== searchPlaceholder) {
    if (searchString[0] ==  '#') {
      userListFitleredBySearchString = userListFilteredByRoles.filter((u) => JSON.stringify(u, (key, value) => (value || ''), 4).replace(/"([^"]+)":/g, '$1:').includes(searchString.slice(1)))
    } else {
      userListFitleredBySearchString = userListFilteredByRoles.filter((u) => u.email.includes(searchString) || (u.fullname && u.fullname.toLowerCase().includes(searchString.toLowerCase())) || u.id.toLowerCase().includes(searchString.toLowerCase()))
    }

  } else {
   userListFitleredBySearchString = userListFilteredByRoles
  }


  const pageCount = Math.ceil(userListFitleredBySearchString.length / PAGE_SIZE)
  const pageStart = (page - 1) * PAGE_SIZE
  const pageEnd = page * PAGE_SIZE
  const pageArray = createArray(pageCount)

  const pagedUserList = userListFitleredBySearchString.slice(pageStart, pageEnd)

  // console.log(pageStart + 1, pageEnd <= userListFitleredBySearchString.length ? pageEnd : userListFitleredBySearchString.length, userListFitleredBySearchString.length)
  let selectedUserComponent = ''
  if (profileVisible.id) {
    selectedUserComponent = <AdminUserPage user={profileVisible} writeAccess={writeAccess} token={token} handleProfileSelect={handleProfileSelect} refreshUserList={refreshUserList} availableRoles={availableRoles} />
  }

  const filterComponent = !isLoadingUserList ? (
    <>
      <input className={css(styles.tokenInput)} value={searchString} onChange={handleSearch} onFocus={handleSearchFocus} onBlur={handleSearchBlur}  />
      <div className={css(styles.availableRoles)}>
        {availableRoles.map((role) => {
          return role.roleName !== 'ROLE_USER' ? <div className={css(styles.availableRole)} style={selectedRoles.includes(role.roleName) ? {background: 'rgb(75, 110, 153)', color: '#fff'} : {}} onClick={() => handleRoleSelection(role.roleName)} title={role.description} >{role.roleName}</div> : ''
        })}
      </div>
    </>
  ) : ''
  const pageComponent = !isLoadingUserList ? (
    <>
      <div className={css(styles.userListPager)}>
        <div><div className={css(styles.userListPageChanger)} style={page === 1 ? {color: '#ccc', borderColor: '#ccc', cursor: 'default'} : {}} onClick={page === 1 ? noop : () => handlePageChange(page - 1)}>Previous</div></div>
        <div className={css(styles.userListPageNumbers)}>
          {pageArray.map(i => {
            return <div className={css(styles.userListPageNumber)} style={page === i+1 ? {background: 'rgb(75, 110, 153)', color: '#fff', cursor: 'default'} : {}} onClick={() => handlePageChange(i+1)}>{i+1}</div>
          })}
        </div>
        <div><div className={css(styles.userListPageChanger)} style={page === pageCount ? {color: '#ccc', borderColor: '#ccc', cursor: 'default'} : {}} onClick={page === pageCount ? noop : () => handlePageChange(page + 1)}>Next</div></div>
      </div>
      <div className={css(styles.userListPageCount)}>
        {`${pageStart + 1} - ${pageEnd <= userListFitleredBySearchString.length ? pageEnd : userListFitleredBySearchString.length} of ${userListFitleredBySearchString.length}`}
      </div>
    </>
  ) : ''
  return readAccess ? (
    <div>
      <Loading isLoading={isLoadingUserList} />
      <div className={css(styles.userListContainer)}>
        <div className={css(styles.availableRoles)}>
          {domainIds.map((domanId) => {
            return <div className={css(styles.availableRole)} style={selectedDomain === domanId ? {background: 'rgb(75, 110, 153)', color: '#fff'} : {}} onClick={() => handleDomainSelection(domanId)}>{domanId}</div>
          })}
        </div>
        {filterComponent}
        {pageComponent}
        <div>
          <ul className={css(styles.list)}>
            {pagedUserList.map((u) => {
              return (
                <li key={u.id} className={css(styles.listItem)} onClick={() => handleProfileSelect(u)}>
                  <div><img src={imgPlaceholder} className={css(styles.listItemImage)} /></div>

                  <div className={css(styles.listItemContent)}>
                    <h4 className={css(styles.listItemContentH4)} >{u.fullname || u.email}</h4>
                    <p className={css(styles.listItemContentP)} >{u.email}</p>
                    <p className={css(styles.listItemContentP)} >{u.id}</p>
                  </div>
                  <div className={css(styles.listItemContent)}>
                    {u.roles && u.roles.map((role) => <h4 className={css(styles.listItemContentRole)} >{role}</h4>)}
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
        {pageComponent}
      </div>
      {selectedUserComponent}
    </div>
  ) : <div className={css(styles.accessDenied)} >Access Denied, need users:read scope to list all users</div>
}

AdminUserListContainer.propTypes = {
  accessToken: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  return {
    accessToken: getAccessToken(state),
    user: state.get('user'),
    domainIds: state
      .getIn(['versions', 'all'], _.List())
      .map((versionsData) => {
        return versionsData.get('id')
      })
      .sortBy((id) => id),
  }
}

export default connect(mapStateToProps, {})(AdminUserListContainer)
